import React from 'react'
import { Navbar, Nav, Container, Row, Col } from 'react-bootstrap'
import { Link } from 'gatsby'
import {
  AiFillTwitterSquare,
  AiFillInstagram,
  AiFillFacebook
} from 'react-icons/ai'
import BrLogo from '../../assets/br_icon.svg'
const layout = ({ children }) => {
  return (
    <>
      <header>
        <Navbar
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}
          collapseOnSelect
          expand='lg'
          fixed='top'
          role='navigation'
          className='text-center'
        >
          <Navbar.Brand>
            <Link
              style={{
                boxShadow: 'none',
                textDecoration: 'none',
                color: 'gray'
              }}
              to='/'
            >
              <BrLogo
                width='46'
                height='30'
                className='d-inline-block align-top'
                alt='React Bootstrap logo'
              />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls='navbarSupportedContent'
            aria-expanded='false'
            aria-label='Toggle navigation'
          />
          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav
              className='ml-auto'
              style={{
                color: '#273C75',
                fontFamily: 'roboto',
                fontSize: '24px'
              }}
            >
              <Nav.Link>
                <Link
                  style={{
                    boxShadow: 'none',
                    textDecoration: 'none',
                    color: 'gray'
                  }}
                  to='work'
                >
                  Work
                </Link>
              </Nav.Link>

              <Nav.Link>
                <Link
                  style={{
                    boxShadow: 'none',
                    textDecoration: 'none',
                    color: 'gray'
                  }}
                  to='blog'
                >
                  Blog
                </Link>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </header>
      <main>{children}</main>
      <footer className='text-center'>
        <div
          style={{
            marginTop: '25px',
            background: '#F1F3FA',
            textAlign: 'center'
          }}
        >
          <Container>
            <Row style={{ padding: '25px' }}>
              <Col lg={4} md={4} sm={12}>
                <a href='https://twitter.com/SomoyKhan'>
                  <AiFillTwitterSquare
                    style={{ fontSize: '72px', color: '#ABC8FB' }}
                  />
                </a>
              </Col>

              <Col lg={4} md={4} sm={12}>
                <a href='https://www.instagram.com/somoykhan/'>
                  <AiFillInstagram
                    style={{ fontSize: '72px', color: '#ABC8FB' }}
                  />
                </a>
              </Col>

              <Col lg={4} md={4} sm={12}>
                <a href='https://www.facebook.com/sporsho.somoy/'>
                  <AiFillFacebook
                    style={{ fontSize: '72px', color: '#ABC8FB' }}
                  />
                </a>
              </Col>
            </Row>
          </Container>
        </div>

        <div
          style={{
            background: '#F1F3FC',
            textAlign: 'center',
            color: 'white',
            padding: '1.5em'
          }}
        >
          <h5>
            © {new Date().getFullYear()}, All Rights Reserved{' '}
            <strong>Somoy Khan</strong>
          </h5>
        </div>
      </footer>
    </>
  )
}

export default layout
